import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';

const FloorSelector = observer(({ interactiveRef }) => {
    const { mapStore } = useStores();

    const changeFloor = (floorId) => {
        mapStore.setActiveFloorId(floorId);
        interactiveRef.current.changeActiveFloor(floorId, false);
    };

    return (
        <div className="relative flex justify-center items-center gap-1 sm:gap-3 mt-[22px]">
            {mapStore.floors
                .slice()
                .sort((a, b) => {
                    const parseFloor = (name) => {
                        const match = name.match(/^([A-Za-z]+)(\d+)$/);
                        return match
                            ? { prefix: match[1], num: parseInt(match[2], 10) }
                            : { prefix: name, num: 0 };
                    };

                    const floorA = parseFloor(a.name);
                    const floorB = parseFloor(b.name);

                    const order = ['B', 'L'];

                    const prefixAIndex = order.indexOf(floorA.prefix);
                    const prefixBIndex = order.indexOf(floorB.prefix);

                    if (prefixAIndex !== prefixBIndex) {
                        return prefixAIndex - prefixBIndex;
                    }

                    return floorA.num - floorB.num;
                })

                .map((floor, i) => (
                    <button
                        className={`${
                            mapStore.activeFloorId === floor._id
                                ? 'bg-[#F26322] text-white font-semibold'
                                : 'bg-[#FCFCFC] text-[#1C1C1C] border-[1px] border-[#1C1C1C]'
                        }
                        h-7 w-11 
                        sm:h-9 sm:w-[60px]
                        `}
                        style={{ backdropFilter: 'blur(60px)' }}
                        onClick={() => changeFloor(floor._id)}
                    >
                        <p className="text-[14px] md:text-base tracking-[.08em]">
                            {floor.name}
                        </p>
                    </button>
                ))}
        </div>
    );
});

export default FloorSelector;
